const VALIDATION = {
  required:            'Campo requerido.',
  minlength:           'Cantidad mínima de caracteres erronea.',
  maxlength:           'Cantidad máxima de caracteres superada.',
  email:               'Email inválido.',
  password:            'Contraseña inválida.',
  mismatched_password: 'La contraseña no coincide.'
}

export default VALIDATION;
